import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ComplianceAreaService,
  ControlItemsService,
  TenantService
} from '../../_services/index';

import {ComplianceArea, ControlItem, User} from '../../_models/index';

import {LoginHelper, Recurring} from '../../helpers/index';

import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {DocumentSelectComponent} from "../documentSelect";
import {IndexConfigService} from "../../_services/index.config.service";
import {PolicyService} from "../../_services/policy.service";
import {Policy} from "../../_models/policy";
import {SelectPolicyComponent} from "../selectPolicy/select-policy.component";
import {TenantPermissions} from "../../_models/tenantPermissions";
import {AddUrlComponent} from "../addUrl/add-url.component";
import {AddLinkReferenceResourceComponent} from "../addLinkRefrenceResource/add-link-reference-resource.component";
import {ReferenceResourceService} from "../../_services/referemceResource.service";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {
  AddLinkRecommendedSolutionComponent
} from "../addLinkRecommendedSolution/add-link-recommended-solution.component";

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'control.item.component.html',
  styleUrls: ['./control.item.component.scss'],
})

export class ControlItemComponent implements OnInit {
  loading = false;
  controlItem: ControlItem;
  controlItemOrigin: ControlItem;
  controlType :string= "Unexisting";
  controlItemId: number;
  recurringList: any[] = [];
  complianceAreas: ComplianceArea[];
  isNotHiddenForComplianceArea: boolean;
  rowGroupMetadata: any;
  parent: ControlItem;
  currentUser: User;
  recommendedSolutions;
  recommendedSolutionCols : any[] = [
    {'field': 'name', 'header': 'Reference Resource'},
    {'field': 'description', 'header': 'Description'},
    {'field': 'contact', 'header': 'Contact'}
  ];
  referenceResources;
  referenceResourceCols : any[] = [
    {'field': 'name', 'header': 'Reference Resource'},
    {'field': 'sourceProvider', 'header': 'Source/Provider'},
    {'field': 'note', 'header': 'Notes'}
  ];

  cols : any[] = [
    {'field': 'complianceArea.name', 'header': 'Framework'},
    {'field': 'practice', 'header': 'Practice'},
    {'field': 'label', 'header': 'Label'},
    {'field': 'category', 'header': 'Category'},
    {'field': 'description', 'header': 'Description'}
  ];

  tenantPermissions: TenantPermissions = {};

  defaultGroups = ["L1", "L2", "L3", "L4", "L5"];
  expanded = {"L1":true, "L2":true, "L3":true, "L4":true, "L5":true}
  public selectDialogRef: MatDialogRef<SelectControlItemComponent>;
visibility: any = {};policies: Policy[] = [];selectedPolicies: Policy[] = [];
  constructor(public config: IndexConfigService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ControlItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public controlItemsService: ControlItemsService,
    public alertService: AlertService,
    public referenceResourceService: ReferenceResourceService,
    public recommendedSolutionService: RecommendedSolutionService,
    public complianceAreaService: ComplianceAreaService,
    public tenantService: TenantService,
  public policyService: PolicyService
  ) {
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({ label: Recurring[i].toString(), value: i });
    }
    this.controlItemId = route.snapshot.params['controlItemId'];
    this.parent = data['parent'];
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.tenantService.getCurrent().subscribe(p => {
      this.tenantPermissions = p;
    });

    this.controlItem = Object.assign({}, this.data.controlItem);
    this.complianceAreaService.getInfoComplianceAreas(tenantName).subscribe(complianceAreas => {
      this.complianceAreas = complianceAreas;
      this.onAreaChange();
    });
    this.updateRowGroupMetaData();

    this.policyService.getAllPolicys().subscribe(p => {
      console.log("Policy set")
      this.policies = p;
      const ids = (this.controlItem.policyIds || '').split(',');
      this.selectedPolicies = this.policies.filter(i => ids.indexOf(i.id.toString()) >= 0);
    })

    this.recommendedSolutionService.getRecommendedSolutions(this.controlItem.controlItemId).subscribe(p => {
      this.recommendedSolutions = p;
    });

    this.referenceResourceService.getReferenceResources(this.controlItem.controlItemId).subscribe(p => {
      this.referenceResources = p;
    });
  }

  onSave() {

    this.loading = true;

    this.alertService.clear();

    this.controlItem.tenantName = LoginHelper.getTenantName();
    this.controlItem.policyIds = this.selectedPolicies.map(p => p.id).join(',');
    for(let key in this.controlItem)
    if (this.controlItem.hasOwnProperty(key) && this.controlItem[key] && typeof(this.controlItem[key]) == "string")
    {
      this.controlItem[key] = this.controlItem[key].replace(/^<p[^>]*>|<\/p>$/g, '');
    }

    if (this.controlItem.controlItemId) {
      this.controlItemsService.update(this.controlItem)
        .subscribe(
          data => {
            this.alertService.success('The item data was updated.', true);
            this.loading = false;

            this.onClose();
          },
          error => {
            this.loading = false;
            const message = "An error occurred while updating item.";
            this.alertService.error(message);
          });
    } else {
      this.controlItemsService.create(this.controlItem)
        .subscribe(
          data => {
            this.alertService.success('The item data was updated.', true);
            this.loading = false;

            this.onClose();
          },
          error => {
            this.loading = false;
            const message = "An error occurred while updating item.";
            this.alertService.error(message);
          });
    }
  }

  onClose(): void {
    this.dialogRef.close(this.controlItem);
  }

  onAreaChange(){
    this.isNotHiddenForComplianceArea = this.complianceAreas.find(a => a.complianceAreaId == this.controlItem.complianceAreaId).isExtended;
  }

  addSubItem() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: this.controlItem.subItems || []
      }
    };

    this.selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    this.selectDialogRef.afterClosed().subscribe((data: any) => {
      data.level = data.level || this.defaultGroups[0];
      this.controlItem.subItems = this.controlItem.subItems || [];
      this.controlItem.subItems.push(data);
      this.updateRowGroupMetaData();
    });
  }

  removeSubItem(item){
    this.controlItem.subItems = this.controlItem.subItems.filter(i => i != item);
    this.updateRowGroupMetaData();
  }

  addPolicy(){
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: 'auto',
      height: '600px',

      data: {policies: this.policies.filter(p => this.selectedPolicies.indexOf(p) < 0)}
    };
    console.log('bag')
    console.log(this.policies);
    console.log(this.selectedPolicies);

    let selectPolicyDialogRef = this.dialog.open(SelectPolicyComponent, config);

    selectPolicyDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.selectedPolicies.push(result);
      }
    });
  }

  removePolicy(i){
    this.selectedPolicies = this.selectedPolicies.filter(c => c != i);
  }

  updateRowGroupMetaData() {
    this.controlItem.subItems = this.controlItem.subItems || [];
    this.controlItem.subItems = this.controlItem.subItems.sort((a, b) => a.level > b.level ? 1 : a.level < b.level ? -1 : a.description > b.description ? 1 : -1);
    this.controlItem.subItems.forEach(g => {
      if (this.defaultGroups.indexOf(g.level) < 0)
      {
        this.defaultGroups.push(g.level);
        this.expanded[g.level] = true;
        this.defaultGroups = this.defaultGroups.sort((a, b) => a > b ? 1 : -1);
      }
    });

    this.rowGroupMetadata = {};
    if (this.controlItem.subItems) {
      for (let i = 0; i < this.controlItem.subItems.length; i++) {
        let rowData = this.controlItem.subItems[i];
        let brand = rowData.level;
        /*for (var j = 0; j < this.defaultGroups.length; j++)
        {
          if (this.defaultGroups[j] == brand)
          {
            break;
          }
          if (!this.rowGroupMetadata[this.defaultGroups[j]])
          {
            this.rowGroupMetadata[this.defaultGroups[j]] = {index: i, size: 0};
          }
        }*/
        if (i == 0) {
          this.rowGroupMetadata[brand] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.controlItem.subItems[i - 1];
          let previousRowGroup = previousRowData.level;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = { index: i, size: 1 };
        }
      }
    }
  }

  moveUp(item)
  {
    item.level = this.defaultGroups[this.defaultGroups.indexOf(item.level) + 1];
    this.updateRowGroupMetaData();
  }

  moveDown(item)
  {
    item.level = this.defaultGroups[this.defaultGroups.indexOf(item.level) - 1];
    this.updateRowGroupMetaData();
  }

  edit(item){
    let config: MatDialogConfig = {
      width: '80%',
      height: '90%',
      data: {
        controlItem: item,
        parent: this.controlItem
      }
    };

    const dialogRef = this.dialog.open(ControlItemComponent, config);

  }

  selectDocument(node){
    const q = window['quill'];

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {}
    };


    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result)
      {
        const quill = window['quills'].find(q => q.container === node.closest(".p-editor-container").querySelector(".ql-container"));
        const url = this.config.api + "/api/attachments/file?name=" + encodeURIComponent(result._orgData.name) + "&path=" + (result._orgData.folderId || "");
        quill.format('link', url, 'user');
      }
    });
  }

  addToken(html)
  {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }
}
